import { Component, OnDestroy, OnInit } from '@angular/core';
import { PostDO } from '../../common/data-objects/PostDO';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../../common/services/seo.service';
import { PostsService } from '../../common/services/posts.service';
import { Utils } from '../../common/utils/Utils';

@Component({
  selector: 'app-single-craft-page',
  templateUrl: './single-craft-page.component.html',
  styleUrls: ['./single-craft-page.component.scss']
})
export class SingleCraftPageComponent implements OnInit, OnDestroy {
  post: PostDO;
  isLoading: boolean;
  slug: string;

  private paramMapSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private meta: Meta,
    private seoService: SeoService,
    private postsService: PostsService
  ) {
    this.paramMapSubscription = this.activatedRoute.paramMap.subscribe((paramMap) => {
      this.slug = paramMap.get('slug');
    });
  }

  ngOnInit() {
    this.getData();
  }

  ngOnDestroy() {
    if (this.paramMapSubscription) {
      this.paramMapSubscription.unsubscribe();
    }
  }

  private getData() {
    this.isLoading = true;
    this.postsService.getPostBySlug(this.slug).subscribe((post) => {
      this.post = post;
      const title = `${Utils.removeUnicode(this.post.title.rendered)} - Fun Bible`;
      this.seoService.setTitle(title);
      this.isLoading = false;
      this.seoService.setDescription(this.post.excerpt.rendered);
      this.meta.updateTag({ property: 'og:url', content: `https://funbible.net/cartoons/${post.slug}` });
      this.meta.updateTag({
        property: 'og:image',
        content: this.post.featuredImage
      });
      const initialKeywords = ['desene animate crestine', 'filme animate biblice', 'animatii', 'desene animate online', 'desen animat'];
      const dynamicKeywords = this.post.tags.slice(0, 5);
      const finalKeywords = [...initialKeywords, ...dynamicKeywords].join();
      this.meta.updateTag({property: 'keywords', content: finalKeywords});

      this.angulartics2.eventTrack.next({
        action: title,
        properties: { category: 'pageView' },
      });
    }, () => {
      this.toastr.error('Acest conținut nu există!');
      this.isLoading = false;
    });
  }
}
